// shared/editable-text.directive.ts
import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { EditorService } from '../../services/editor.service';
import { InlineTextEditorComponent } from '../inline-edit-text/inline-text-editor-component.component';

import { InnerHtml } from '../models/content.model';

@Directive({
  selector: '[appEditableText]',
  standalone: true,
})
export class EditableTextDirective implements OnDestroy {
  @Output() appEditableTextSave = new EventEmitter<InnerHtml>();

  private editorRef: ComponentRef<InlineTextEditorComponent> | null = null;

  constructor(
    private host: ElementRef<HTMLElement>,
    private vcr: ViewContainerRef,
    private editorService: EditorService,
    private cfr: ComponentFactoryResolver,
  ) {
  }

  @HostListener('click', ['$event'])
  onClick(ev: MouseEvent) {
    // sprawdzamy czy jesteśmy w trybie edycyjnym
    if (
      !this.editorService.isEditModeEnabled() ||
      this.editorService.clickButton
    ) {
      return;
    }
    if (this.editorRef) {
      return;
    } // już edytujemy
    if (this.host.nativeElement.closest('app-slider')) {
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();

    const originalEl = this.host.nativeElement;
    const initialText = originalEl;

    /* 2. tworzymy edytor dokładnie w tym samym kontenerze */
    const factory = this.cfr.resolveComponentFactory(InlineTextEditorComponent);
    this.editorRef = this.vcr.createComponent(factory);
    this.editorRef.setInput?.('value', initialText);

    if (!this.editorRef.setInput) {
      this.editorRef.setInput?.('value', initialText);
      this.editorRef.changeDetectorRef.detectChanges();
    }

    this.editorRef.location.nativeElement.classList.add(
      ...Array.from(originalEl.classList),
    );

    originalEl.style.display = 'none';

    const finish = () => {
      subSave.unsubscribe();
      subCancel.unsubscribe();
      this.removeAllToolbars();
      this.editorRef?.destroy();
      this.editorRef = null;
      originalEl.style.display = 'block';
      this.editorService.unregister(finish);
    };

    this.editorService.register(finish);

    /* 3. obsługa zapisu */
    const subSave = this.editorRef.instance.save.subscribe(
      (html: InnerHtml) => {
        if (html) {
          originalEl.innerHTML = html.innerHTML;
          this.appEditableTextSave.emit(html); // rodzic może zapisać w bazie
        }
        finish();
      },
    );

    /* 4. obsługa anulowania */
    const subCancel = this.editorRef.instance.cancelModal.subscribe(() =>
      finish(),
    );
  }

  removeAllToolbars() {
    document
      .querySelectorAll('.ite-toolbar')
      .forEach((el) => el.parentNode?.removeChild(el));
  }

  ngOnDestroy() {
    this.editorRef?.destroy();
  }

  gap = 8;
}
